export default "__VITE_ASSET__BBKPxXKR__"